import React, { useState, useEffect } from 'react';
import moment from 'moment'; // Importa moment.js
import 'moment/locale/it'; // Importa il locale italiano

function Cerca() {
  const [searchTerm, setSearchTerm] = useState('');
  const [regione, setRegione] = useState('');
  const [prov, setProv] = useState('');
  const [comune, setComune] = useState('');
  const [cap, setCap] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [searchPerformed, setSearchPerformed] = useState(false);

   const province = [
    { sigla: 'AG', nome: 'Agrigento' },
    { sigla: 'AL', nome: 'Alessandria' },
    { sigla: 'AN', nome: 'Ancona' },
    { sigla: 'AO', nome: 'Aosta' },
    { sigla: 'AR', nome: 'Arezzo' },
    { sigla: 'AP', nome: 'Ascoli Piceno' },
    { sigla: 'AT', nome: 'Asti' },
    { sigla: 'AV', nome: 'Avellino' },
    { sigla: 'BA', nome: 'Bari' },
    { sigla: 'BT', nome: 'Barletta-Andria-Trani' },
    { sigla: 'BL', nome: 'Belluno' },
    { sigla: 'BN', nome: 'Benevento' },
    { sigla: 'BG', nome: 'Bergamo' },
    { sigla: 'BI', nome: 'Biella' },
    { sigla: 'BO', nome: 'Bologna' },
    { sigla: 'BZ', nome: 'Bolzano' },
    { sigla: 'BS', nome: 'Brescia' },
    { sigla: 'BR', nome: 'Brindisi' },
    { sigla: 'CA', nome: 'Cagliari' },
    { sigla: 'CL', nome: 'Caltanissetta' },
    { sigla: 'CB', nome: 'Campobasso' },
    { sigla: 'CI', nome: 'Carbonia-Iglesias' },
    { sigla: 'CE', nome: 'Caserta' },
    { sigla: 'CT', nome: 'Catania' },
    { sigla: 'CZ', nome: 'Catanzaro' },
    { sigla: 'CH', nome: 'Chieti' },
    { sigla: 'CO', nome: 'Como' },
    { sigla: 'CS', nome: 'Cosenza' },
    { sigla: 'CR', nome: 'Cremona' },
    { sigla: 'KR', nome: 'Crotone' },
    { sigla: 'CN', nome: 'Cuneo' },
    { sigla: 'EN', nome: 'Enna' },
    { sigla: 'FM', nome: 'Fermo' },
    { sigla: 'FE', nome: 'Ferrara' },
    { sigla: 'FI', nome: 'Firenze' },
    { sigla: 'FG', nome: 'Foggia' },
    { sigla: 'FC', nome: 'Forlì-Cesena' },
    { sigla: 'FR', nome: 'Frosinone' },
    { sigla: 'GE', nome: 'Genova' },
    { sigla: 'GO', nome: 'Gorizia' },
    { sigla: 'GR', nome: 'Grosseto' },
    { sigla: 'IM', nome: 'Imperia' },
    { sigla: 'IS', nome: 'Isernia' },
    { sigla: 'SP', nome: 'La Spezia' },
    { sigla: 'AQ', nome: "L'Aquila" },
    { sigla: 'LT', nome: 'Latina' },
    { sigla: 'LE', nome: 'Lecce' },
    { sigla: 'LC', nome: 'Lecco' },
    { sigla: 'LI', nome: 'Livorno' },
    { sigla: 'LO', nome: 'Lodi' },
    { sigla: 'LU', nome: 'Lucca' },
    { sigla: 'MC', nome: 'Macerata' },
    { sigla: 'MN', nome: 'Mantova' },
    { sigla: 'MS', nome: 'Massa-Carrara' },
    { sigla: 'MT', nome: 'Matera' },
    { sigla: 'ME', nome: 'Messina' },
    { sigla: 'MI', nome: 'Milano' },
    { sigla: 'MO', nome: 'Modena' },
    { sigla: 'MB', nome: 'Monza e della Brianza' },
    { sigla: 'NA', nome: 'Napoli' },
    { sigla: 'NO', nome: 'Novara' },
    { sigla: 'NU', nome: 'Nuoro' },
    { sigla: 'OG', nome: 'Ogliastra' },
    { sigla: 'OT', nome: 'Olbia-Tempio' },
    { sigla: 'OR', nome: 'Oristano' },
    { sigla: 'PD', nome: 'Padova' },
    { sigla: 'PA', nome: 'Palermo' },
    { sigla: 'PR', nome: 'Parma' },
    { sigla: 'PV', nome: 'Pavia' },
    { sigla: 'PG', nome: 'Perugia' },
    { sigla: 'PU', nome: 'Pesaro e Urbino' },
    { sigla: 'PE', nome: 'Pescara' },
    { sigla: 'PC', nome: 'Piacenza' },
    { sigla: 'PI', nome: 'Pisa' },
    { sigla: 'PT', nome: 'Pistoia' },
    { sigla: 'PN', nome: 'Pordenone' },
    { sigla: 'PZ', nome: 'Potenza' },
    { sigla: 'PO', nome: 'Prato' },
    { sigla: 'RG', nome: 'Ragusa' },
    { sigla: 'RA', nome: 'Ravenna' },
    { sigla: 'RC', nome: 'Reggio Calabria' },
    { sigla: 'RE', nome: 'Reggio Emilia' },
    { sigla: 'RI', nome: 'Rieti' },
    { sigla: 'RN', nome: 'Rimini' },
    { sigla: 'RM', nome: 'Roma' },
    { sigla: 'RO', nome: 'Rovigo' },
    { sigla: 'SA', nome: 'Salerno' },
    { sigla: 'VS', nome: 'Medio Campidano' },
    { sigla: 'SS', nome: 'Sassari' },
    { sigla: 'SV', nome: 'Savona' },
    { sigla: 'SI', nome: 'Siena' },
    { sigla: 'SR', nome: 'Siracusa' },
    { sigla: 'SO', nome: 'Sondrio' },
    { sigla: 'TA', nome: 'Taranto' },
    { sigla: 'TE', nome: 'Teramo' },
    { sigla: 'TR', nome: 'Terni' },
    { sigla: 'TO', nome: 'Torino' },
    { sigla: 'TP', nome: 'Trapani' },
    { sigla: 'TN', nome: 'Trento' },
    { sigla: 'TV', nome: 'Treviso' },
    { sigla: 'TS', nome: 'Trieste' },
    { sigla: 'UD', nome: 'Udine' },
    { sigla: 'VA', nome: 'Varese' },
    { sigla: 'VE', nome: 'Venezia' },
    { sigla: 'VB', nome: 'Verbano-Cusio-Ossola' },
    { sigla: 'VC', nome: 'Vercelli' },
    { sigla: 'VR', nome: 'Verona' },
    { sigla: 'VV', nome: 'Vibo Valentia' },
    { sigla: 'VI', nome: 'Vicenza' },
    { sigla: 'VT', nome: 'Viterbo' },
  ];

  const regioni = [
    { sigla: 'Abruzzo', nome: 'Abruzzo' },
    { sigla: 'Basilicata', nome: 'Basilicata' },
    { sigla: 'Calabria', nome: 'Calabria' },
    { sigla: 'Campania', nome: 'Campania' },
    { sigla: 'Emilia Romagna', nome: 'Emilia Romagna' },
    { sigla: 'Friuli Venezia Giulia,', nome: 'Friuli Venezia Giulia,' },
    { sigla: 'Lazio', nome: 'Lazio' },
    { sigla: 'Liguria', nome: 'Liguria' },
    { sigla: 'Lombardia', nome: 'Lombardia' },
    { sigla: 'Marche', nome: 'Marche' },
    { sigla: 'Molise ', nome: 'Molise ' },
    { sigla: 'Piemonte', nome: 'Piemonte' },
    { sigla: 'Puglia', nome: 'Puglia' },
    { sigla: 'Sardegna', nome: 'Sardegna' },
    { sigla: 'Sicilia', nome: 'Sicilia' },
    { sigla: 'Toscana', nome: 'Toscana' },
    { sigla: 'Trentino Alto Adige', nome: 'Trentino Alto Adige' },
    { sigla: 'Umbria', nome: 'Umbria' },
    { sigla: 'Veneto', nome: 'Veneto' },
    { sigla: 'Valle d\'Aosta', nome: 'Valle d\'Aosta' },
  ];
  
  
  const handleImageClick = (event, imageUrl) => {
    event.preventDefault(); // Previeni il comportamento di default del link
    setSelectedImage(imageUrl);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSearchPerformed(true);
    try {
      const response = await fetch('/api/ricerca', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          searchTerm,
          regione,
          prov,
          comune,
          cap
        })
      });

      if (response.ok) {
        const results = await response.json();
        setSearchResults(results);
      } else {
        // Gestisci l'errore
        console.error('Errore nella ricerca:', response.statusText);
      }
    } catch (err) {
      // Gestisci l'errore
      console.error('Errore nella ricerca:', err);
    }
  };

  return (
    <div className='container'>
        <h2 className='mt_50'>Cerca Annunci</h2>
        <form onSubmit={handleSubmit} className="mt_50 mb_50">
            <div className="row">
                <div className="col-12 mt_10">
                    <input 
                    type="text" 
                    className="form-control mb-3"
                    placeholder="NOME e/o COGNOME" 
                    id="searchTerm"
                    name="searchTerm"
                    value={searchTerm} 
                    onChange={(e) => setSearchTerm(e.target.value)} 
                    />
                </div>
                {/* <select className="form-control mb-3" id="regione" name="regione" value={regione} onChange={(e) => setRegione(e.target.value)}>
                    <option>REGIONE</option>
                    {regioni.map(regione => (
                        <option key={regione.sigla} value={regione.sigla}>
                            {regione.nome.charAt(0) + regione.nome.slice(1)}
                        </option>
                    ))}
                </select> */}
                
                <div className='col-12 mt_10'>
                    <input 
                    type="text" 
                    className="form-control mb-3"
                    placeholder="COMUNE" 
                    id="comune"
                    name="comune"
                    value={comune} 
                    onChange={(e) => setComune(e.target.value)} 
                    />
                </div>
                <div className='col-4 mt_10'>
                    <select className="form-control mb-3" id="prov" name="prov" value={prov} onChange={(e) => setProv(e.target.value)}>
                        <option>PROVINCIA</option>
                        {province.map(prov => (
                            <option key={prov.sigla} value={prov.sigla}>
                                {prov.nome.charAt(0) + prov.nome.slice(1)}
                            </option>
                        ))}
                    </select>
                </div>
                <div className='col-4 mt_10'>
                    <input 
                    type="text" 
                    className="form-control mb-3"
                    placeholder="CAP" 
                    id="cap"
                    name="cap"
                    value={cap} 
                    onChange={(e) => setCap(e.target.value)} 
                    />
                </div>
                <div className='col-4 mt_10'><button type="submit" className='btn btn-primary'>Cerca</button></div>
            </div>
        </form>
        
        {searchResults.length > 0 ? (
            <div className='row'>
            {searchResults.map(annuncio => (
                <div className="col-md-4 col-sm-6 col-xs-12 mb_30 mt_30" key={annuncio._id}>
                        <div className="card">
                            <a 
                            href={`/necrologi/${annuncio.id_utente}/${annuncio.img}`} 
                            target="_blank" 
                            rel="noreferrer" 
                            title="Visualizza"
                            onClick={(event) => handleImageClick(event, `/necrologi/${annuncio.id_utente}/${annuncio.img}`)} // Aggiungi onClick
                            >
                            <img 
                                src={`/necrologi/${annuncio.id_utente}/${annuncio.img}`} 
                                className="card-img-top" 
                                alt={`${annuncio.nome} ${annuncio.cognome}`} 
                            />
                            </a>
                            <div className="card-body">
                                <h5 className="card-title text-center"><a href={`/necrologi/${annuncio.id_utente}/${annuncio.img}`} target="_blank" rel="noreferrer" title="Visualizza">{annuncio.nome} {annuncio.cognome}</a></h5>
                                <p className="card-text text-center" style={{marginTop: "-1vh"}}>
                                {moment(annuncio.data_crea).format('dddd DD/MM/YYYY')}<br />
                                {annuncio.comune} ({annuncio.prov}) - {annuncio.regione}<br />
                                Onoranze Funebri: <b>{annuncio.ragSociale}</b>
                                </p>                            
                            </div>
                        </div>
                    </div>
                ))}
                {/* Modale */}
                {modalOpen && (
                <div className="modal">
                    <div className="modal-content">
                    <span className="chiudix" onClick={closeModal}>&times;</span>
                    <img src={selectedImage} alt="Immagine ingrandita" />
                    </div>
                </div>
                )}
            </div>
            ) : (
                <>{searchPerformed && searchResults.length === 0 && ( // Mostra il messaggio solo se searchPerformed è true e non ci sono risultati
                <p>Spiacenti, nessun risultato trovato.</p>
                )}
                </>
        )}
        </div>
  );
}

export default Cerca;